import { createI18n, loadCommonResource, SUPPORTED_LOCALES } from '@artic/i18n';

const NAMESPACES = [
  'common',
  'grid',
  'gridPresets',
  'inbox',
  'jobCards',
  'operatingCosts',
  'planner',
  'project',
  'schedule',
  'validation',
] as const;

const { i18n, I18nProvider, I18nPartnerSync } = createI18n({
  namespaces: NAMESPACES,
  defaultNS: 'common',
  fallbackLng: 'en',
  supportedLngs: SUPPORTED_LOCALES,
  resources: async (lng, ns) => {
    if (ns === 'common') return loadCommonResource(lng);

    // App namespaces currently have no regional differences. Load their full
    // English bundle for every supported English locale so partner overlays
    // can always reset to a complete base resource.
    const mod = await import(`./locales/en/${ns}.json`);
    return mod.default as Record<string, unknown>;
  },
  partnerResources: async (_lng, partnerKey, ns) => {
    const mod = await import(`./locales/en/partners/${partnerKey}/${ns}.json`);
    return mod.default as Record<string, unknown>;
  },
});

export { i18n, I18nPartnerSync, I18nProvider };
